import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Button from "../../../../component/Button/Button";
import Imageurldata from "../../../../Imageurldata";
const JobApplication = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/jobApplication");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        const list = response.data.data.reverse();
        let filteredData=[];
        let liveUrl = Imageurldata ;
        for (let index = 0; index < list.length; index++) {
          
          filteredData.push({...list[index],resumeLink:`${liveUrl}${list[index].resumeLink}`})
        }
       console.log({filteredData});

        setList(filteredData);

        setLoading(false);
      })
      .catch((error) => {
        // alert("Something Went Wrong");
      });
  }, []);
  return (
    <>
      <MaterialTable
        title="Job Applications"
        columns={[
          {
            title: "Date",
            field: "date",
          },
          {
            title: "Time",
            field: "time",
          },
          {
            title: "Name",
            field: "name",
            cellStyle: {
              width: 20,
              maxWidth: 20,
            },
            headerStyle: {
              width: 20,
              maxWidth: 20,
            },
          },
          {
            title: "Email Id",
            field: "emailId",
          },
          { title: "Experience", field: "experience" },
          {
            title: "Phone Number",
            field: "phoneNumber",
          },
          { title: "Post Apply For", field: "postApplyFor" },
          { title: "Qualifications", field: "qualifications" },

          {
            field: "resumeLink",
            title: "Resume Link",
            export:false,
            render: (rowData) => {
              let liveUrl = urldata ;
             return ( <Button
                title=" View Resume"
                onClick={() => {
                  // let testUrl = "http://13.233.110.14:4000/api" 
                 

                  window.open(
                    // liveUrl + rowData.resumeLink,
                   rowData.resumeLink,
                    "_blank" // <- This is what makes it open in a new window.
                  );
                }}
              ></Button>
             )

            //  return `${liveUrl}${rowData.resumeLink}`
              },
          },
          {
            field: "resumeLink",
            title: "Resume Link",
            export:true,
           hidden:true
          },
        ]}
        data={list}
        options={{
          exportButton: {csv:true},
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
};

export default JobApplication;
